import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AfastamentoOutrosComponent } from './afastamento-outros/afastamento-outros.component';
import { AfastamentoSetorComponent } from './afastamento-setor/afastamento-setor.component';
import { AfastamentoComponent } from './afastamento/afastamento.component';
import { AppComponent } from './app.component';
import { AusenciaFaltaComponent } from './ausencia-falta/ausencia-falta.component';
import { AvaliacaoGaugeComponent } from './avaliacao-gauge/avaliacao-gauge.component';
import { AvaliacaoComponent } from './avaliacao/avaliacao.component';
import { BeneficioComponent } from './beneficio/beneficio.component';
import { CardPerfilComponent } from './card-perfil/card-perfil.component';
import { ComissaoComponent } from './comissao/comissao.component';
import { ComprovanteRendimentoComponent } from './comprovante-rendimento/comprovante-rendimento.component';
import { ConfiguracoesComponent } from './configuracoes/configuracoes.component';
import { ConsignadoComponent } from './consignado/consignado.component';
import { ContaPessoalComponent } from './conta-pessoal/conta-pessoal.component';
import { CurriculoComponent } from './curriculo/curriculo.component';
import { DadosFuncionaisComponent } from './dados-funcionais/dados-funcionais.component';
import { DadosPessoaisComponent } from './dados-pessoais/dados-pessoais.component';
import { DependenteComponent } from './dependente/dependente.component';
import { DiariaComponent } from './diaria/diaria.component';
import { ElogioComponent } from './elogio/elogio.component';
import { EnderecoEmailComponent } from './endereco-email/endereco-email.component';
import { EvolucaoCarreiraComponent } from './evolucao-carreira/evolucao-carreira.component';
import { PublicacoesExternasComponent } from './extras/publicacoes-externas/publicacoes-externas.component';
import { FeriadoComponent } from './feriado/feriado.component';
import { FeriasComponent } from './ferias/ferias.component';
import { FrequenciaComponent } from './frequencia/frequencia.component';
import { GaugeComponent } from './gauge/gauge.component';
import { HoleriteComponent } from './holerite/holerite.component';
import { InicioComponent } from './inicio/inicio.component';
import { LicencaComponent } from './licenca/licenca.component';
import { LotacaoComponent } from './lotacao/lotacao.component';
import { MeEncontreComponent } from './me-encontre/me-encontre.component';
import { NaoAutenticadoComponent } from './nao-autenticado/nao-autenticado.component';
import { NotificacaoMostrarComponent } from './notificacao-mostrar/notificacao-mostrar.component';
import { NotificacaoComponent } from './notificacao/notificacao.component';
import { NovoSchedulerComponent } from './novo-scheduler/novo-scheduler.component';
import { OperadoraSemAnsComponent } from './operadora-sem-ans/operadora-sem-ans.component';
import { PessoaDocumentoComponent } from './pessoa-documento/pessoa-documento.component';
import { ProadComponent } from './proad/proad.component';
import { RatingComponent } from './rating/rating.component';
import { Ratting2Component } from './ratting2/ratting2.component';
import { RecadastramentoComponent } from './recadastramento/recadastramento.component';
import { RecursoEstatisticaComponent } from './recurso-estatistica/recurso-estatistica.component';
import { SairComponent } from './sair/sair.component';
import { ServidorInativoComponent } from './servidor-inativo/servidor-inativo.component';
import { SistemasComponent } from './sistemas/sistemas.component';
import { SituacaoEleitoralComponent } from './situacao-eleitoral/situacao-eleitoral.component';
import { SuspensaoComponent } from './suspensao/suspensao.component';
import { TabelaComponent } from './tabela/tabela.component';
import { TempoServicoComponent } from './tempo-servico/tempo-servico.component';
import { WhatsappSolicitacaoCadastroComponent } from './whatsapp-solicitacao-cadastro/whatsapp-solicitacao-cadastro.component';

const routes: Routes = [
  { path: 'inicio', component: InicioComponent },
  {
    path: 'holerite',
    component: HoleriteComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'dados-pessoais',
    component: DadosPessoaisComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'configuracoes',
    component: ConfiguracoesComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'dados-funcionais',
    component: DadosFuncionaisComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'elogio',
    component: ElogioComponent,
    //canActivate: [AuthGuardKC]
  },
  {
    path: 'desconto-dirf',
    component: OperadoraSemAnsComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'beneficio',
    component: BeneficioComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'comprovante-rendimento',
    component: ComprovanteRendimentoComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'consignado',
    component: ConsignadoComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'conta-pessoal',
    component: ContaPessoalComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'avaliacao',
    component: AvaliacaoComponent,
    //canActivate: [AuthGuardKC],
  },
  /*
  desabilitado a pedido do cliente
  chamado 10920 Citsmart
  {
    path: 'banco-horas',
    component: BancoHorasComponent,
    //canActivate: [AuthGuardKC],
  },
   {
    path: 'sgrh-credito',
    component: SgrhCreditoComponent,
    //canActivate: [AuthGuardKC],
  },
  */
  {
    path: 'tempo-servico',
    component: TempoServicoComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'evolucao-carreira',
    component: EvolucaoCarreiraComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'lotacao',
    component: LotacaoComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'curriculo',
    component: CurriculoComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'dependente',
    component: DependenteComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'pessoa-documento',
    component: PessoaDocumentoComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'proad',
    component: ProadComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'me-encontre',
    component: MeEncontreComponent,
    //canActivate: [AuthGuardKC],
  },

  /*{
    path: 'siate',
    component: SiateTicketComponent,
    //canActivate: [AuthGuardKC],
  },*/
  {
    path: 'recadastramento',
    component: RecadastramentoComponent,
    //canActivate: [AuthGuardKC],
  },
  { path: 'sair', component: SairComponent },
  {
    path: 'licenca',
    component: LicencaComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'sistemas',
    component: SistemasComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'recurso-estatistica',
    component: RecursoEstatisticaComponent,
    //canActivate: [AuthGuardKC],
  },

  {
    path: 'frequencia',
    component: FrequenciaComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'afastamento',
    component: AfastamentoComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'ausencia',
    component: AusenciaFaltaComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'suspensao',
    component: SuspensaoComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'ferias',
    component: FeriasComponent,
    //canActivate: [AuthGuardKC]
  },
  {
    path: 'afastamento-outros',
    component: AfastamentoOutrosComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'endereco-email',
    component: EnderecoEmailComponent,
    //canActivate: [AuthGuardKC],
  },
  { path: 'publicacoes/:tipo', component: PublicacoesExternasComponent },
  { path: 'notificacao-mostrar', component: NotificacaoMostrarComponent },
  { path: 'notificacao', component: NotificacaoComponent },
  {
    path: 'feriado',
    component: FeriadoComponent,
    //canActivate: [AuthGuardKC],
  },
  {
    path: 'servidor-inativo',
    component: ServidorInativoComponent,
  },
  //************************ TESTES  */
  {
    path: 'situacao-eleitoral',
    component: SituacaoEleitoralComponent,
  },
  { path: 'nao-autenticado', component: NaoAutenticadoComponent },
  { path: 'publicacoes', component: PublicacoesExternasComponent },
  { path: 'rating', component: RatingComponent },
  {
    path: 'rating2',
    component: Ratting2Component,
  },
  { path: 'tabela', component: TabelaComponent },
  { path: 'gauge', component: GaugeComponent },

  {
    path: 'novo-scheduler',
    component: NovoSchedulerComponent,
  },
  {
    path: 'index', ///:u/:k/:w',
    //pathMatch: 'full',
    component: AppComponent,
  },
  {
    path: 'card',
    component: CardPerfilComponent,
  },
  {
    path: 'cadastro-whatsapp',
    component: WhatsappSolicitacaoCadastroComponent,
  },

  { path: 'diaria', component: DiariaComponent },
  {
    path: 'avaliacao-gauge',
    component: AvaliacaoGaugeComponent,
  },

  {
    path: 'afastamento-setor',
    component: AfastamentoSetorComponent,
  },

  {
    path: 'comissao',
    component: ComissaoComponent,
  },
  //************************ TESTES  */

  { path: '', component: AppComponent },
  // {path: 'ck-editor', component: CkEditorComponent},
  // {path: 'editor-documento', component: EditorDocumentoComponent},
  // {path: 'meus', component: MeusComponentesComponent},
  // {path: 'data-form', component: DataFormComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
